<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <div class="row">
          <div class="md:tw-w-1/3">
            <fieldset class="tw-h-full">
              <legend>
                {{ pageVocabs + "legends.specifications" | translate }}
              </legend>

              <div class="row">
                <!-- title -->
                <div class="cmd:tw-w-full">
                  <form-field
                    [(value)]="model.title"
                    [control]="form?.get('title')"
                    label="common.title"
                  >
                  </form-field>
                </div>

                <!-- WebhookType -->
                <div class="tw-w-full">
                  <enum-select-search
                    class="tw-w-full"
                    enumName="WebhookType"
                    [control]="form?.get('webhookType')"
                    [label]="fields + 'webhookType'"
                    [(value)]="model.webhookType"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                </div>

                <!-- tryCount -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.tryCount"
                    type="tel"
                    [hasNumberSeparator]="true"
                    [control]="form?.get('tryCount')"
                    [label]="fields + 'tryCount'"
                  >
                  </form-field>
                </div>

                <!-- isActive -->
                <div class="md:tw-w-full tw-pt-5">
                  <mat-slide-toggle
                    formControlName="isActive"
                    [(ngModel)]="model.isActive"
                  >
                    {{ "common.active" | translate }}</mat-slide-toggle
                  >
                </div>
              </div>
            </fieldset>
          </div>

          <div class="md:tw-w-2/3">
            <fieldset class="tw-h-full">
              <legend>
                {{ pageVocabs + "legends.address" | translate }}
              </legend>

              <div class="row tw-px-5 tw-pt-4">
                <!-- alert -->
                <div class="tw-mb-3 alert alert-primary">
                  <div class="tw-flex tw-items-center tw-mb-2">
                    <span class="tw-mx-2">●</span>
                    <p class="tw-font-medium m-0">
                      {{ pageVocabs + "messages.description1" | translate }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center">
                    <span class="tw-mx-2">●</span>
                    <p class="tw-font-medium m-0">
                      {{ pageVocabs + "messages.description2" | translate }}
                    </p>
                  </div>
                  <div
                    *ngIf="model.webhookType == WebhookType.Delivery"
                    class="tw-flex tw-items-center"
                  >
                    <span class="tw-mx-2">●</span>
                    <p class="tw-font-medium m-0">
                      {{ pageVocabs + "messages.description4" | translate }}
                    </p>
                  </div>
                </div>

                <!-- url -->
                <div class="tw-w-full tw-relative tw-pt-2">
                  <form-field
                    class=""
                    [(value)]="model.url"
                    [control]="form?.get('url')"
                    [label]="fields + 'url' | translate"
                  >
                  </form-field>
                </div>

                <!-- json -->
                <div
                  class="list-group-item tw-flex tw-justify-start flex-column tw-py-4 bg-light tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md"
                >
                  <h4 class="dark:tw-text-gray-300">
                    {{ pageVocabs + "sampleCode" | translate }}
                  </h4>

                  <div
                    class="tw-pt-5 dark:tw-invert-[1]"
                    id="webhookSampleCode"
                    json-formatter
                    [json]="jsonSampleCode"
                    class="tw-text-left dir-ltr"
                  ></div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
